module.exports = __webpack_public_path__ + "img/0026.7004cd47.gif";